// extracted by mini-css-extract-plugin
module.exports = {"tipContainer":"Tip_tipContainer__2eq0B","tipLegend":"Tip_tipLegend__-4M5v","chosenTip":"Tip_chosenTip__15UhC","customTipWrapper":"Tip_customTipWrapper__13Hg5"};